import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { css } from '@bd/bdui-styles/emotion';
import withData from '@bd/bdcore-data';
import AccessibilityLinks from './AccessibilityLinks';
import HeaderPromoBanner from '../HeaderPromoBanner';
import CourtesyNav from './CourtesyNav';
import HeaderLogo from './HeaderLogo';
import DesktopNav from './DesktopNav';
import ToggleNav from './ToggleNav';
import Search from './Search';
import OSCTagDesktop from './OSCTagDesktop';
import { colors } from '../../styles';

const styles = css`
  position: relative;
  width: 100%;
  z-index: 50;
  background-color: ${colors.white};
  height: 60px;
  @media (min-width: 992px) {
    height: 100px;
  }
  .Header_inner {
    position: fixed;
    width: 100%;
    background-color: ${colors.white};
  }
  .MainNav {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    z-index: 2;
    line-height: 1;
  }
`;

function Header({ widget }) {
  return (
    <header className={styles}>
      <AccessibilityLinks />
      <div className="Header_inner">
        {
          get(widget, 'header_options[0].show_courtesy_nav') &&
          <CourtesyNav />
        }
        <div className="MainNav">
          <HeaderLogo />
          {
            get(widget, 'header_options[0].show_desktop_nav') &&
            <DesktopNav />
          }
          {
            get(widget, 'header_options[0].show_search_button') &&
            <Search />
          }
          <ToggleNav widget={widget} />
          <OSCTagDesktop />
        </div>
        <HeaderPromoBanner />
      </div>
    </header>
  );
}

Header.propTypes = {
  widget: PropTypes.object.isRequired,
};

export default withData(
  {
    widget: 'website_configuration',
  },
)(Header);



// WEBPACK FOOTER //
// ./src/components/Header3/index.js